import isLoginAccountStore from "../store/isLoginAccount";
import loginAccountStore from "../store/isLoginAccount";



// Custom hook để sử dụng và cập nhật cấu hình player
const useIsLoginAccountStore = () => {
    const isLoginAccount = isLoginAccountStore((state) => state.isLoginAccount);
    const setIsLoginAccount = isLoginAccountStore((state) => state.setIsLoginAccount);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        isLoginAccount,
        setIsLoginAccount
    };
};

export default useIsLoginAccountStore;
